/** @format */

import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import {
  IconButton,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { InputV, SelectV, Icons } from 'components';
import { useStyles } from './Style';

import NestedField2 from './NestedField2';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';



const NestedFieldArray = forwardRef((props, ref) => {
  const { nestIndex } = props;
  const classes = useStyles();

  const methods = useFormContext();
  const { control } = methods;

  const { fields, remove, append } = useFieldArray({
    control,
    name: `scInputParams[${nestIndex}].scParameters`,
  });

  const childRef = useRef([]);

  const { scInputParams } = methods.watch();

  useImperativeHandle(ref, () => ({
    addRow() {
      append();
    },
  }));

  return (
    <>
      {fields.map((row, k) => {
        return (
          <React.Fragment key={row.id}>
            <div className={classes.container}>
              <Grid spacing={1} container item xs={12}>
                <div>
                  <IconButton
                    color="primary"
                    variant="contained"
                    aria-label="add"
                    onClick={() => childRef.current[k].addRow()}
                    size="large">
                    <Icons icon="SubdirectoryArrowLeft" color="#343434" size="18" />
                  </IconButton>

                  <IconButton
                    variant="contained"
                    color="secondary"
                    aria-label="delete"
                    onClick={() => remove(k)}
                    size="large">
                    <Icons icon="CloseCircle" color="#343434" size="18" />
                  </IconButton>
                </div>
                <Grid item xs={1}>
                  <InputV
                    fullWidth
                    errors={methods.formState.errors}
                    name={`scInputParams[${nestIndex}].scParameters[${k}].scParameterName`}
                    register={methods.register}
                    rules={['required']}
                    control={methods.control}
                    defaultValue={row.scParameterName}
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={2}>
                  <SelectV
                    name={`scInputParams[${nestIndex}].scParameters[${k}].scParameterType`}
                    options={[
                      { value: 'String', label: 'String' },
                      { value: 'Route', label: 'Route' },
                      { value: 'JSon', label: 'JSon' },
                      { value: 'Array', label: 'Array' },
                      { value: 'XML', label: 'XML' },
                      { value: 'Raw', label: 'Raw' },
                    ]}
                    control={methods.control}
                    rules={['required']}
                    errors={methods.formState.errors}
                    fullWidth
                    defaultValue={row.scParameterType || 'String'}
                    margin="dense"
                  />
                </Grid>
                <Grid item xs={3}>
                  { }

                  <Controller
                    name={`scInputParams[${nestIndex}].scParameters[${k}].typeOfBody`}
                    control={control}
                    render={({ field: props }) => (
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          aria-label="نوع"
                          defaultValue={row.typeOfBody || 'optional'}
                        >
                          <FormControlLabel
                            value="optional"
                            control={<Radio onChange={(e) => props.onChange(e.target.value)} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                            label="اختیاری"
                            labelPlacement="top"
                          />
                          <FormControlLabel
                            value="required"
                            control={<Radio onChange={(e) => props.onChange(e.target.value)} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                            label="اجباری"
                            labelPlacement="top"
                          />
                          <FormControlLabel
                            value="hidden"
                            control={<Radio onChange={(e) => props.onChange(e.target.value)} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                            label="مخفی"
                            labelPlacement="top"
                          />
                        </RadioGroup>
                      </FormControl>
                    )}
                    defaultValue={row.typeOfBody || 'optional'}
                  />
                </Grid>

                { }

                {/*  */}
                <Grid item xs={2}>
                  {fields.length &&
                    scInputParams &&
                    scInputParams.length &&
                    scInputParams[nestIndex]?.scParameters &&
                    scInputParams[nestIndex]?.scParameters[k]?.typeOfBody === 'required' ? (
                    <InputV
                      errors={methods.formState.errors}
                      name={`scInputParams[${nestIndex}].scParameters[${k}].scParameterDefaultValue`}
                      register={methods.register}
                      fullWidth
                      control={methods.control}
                      defaultValue=""
                      margin="dense"
                      disabled
                    />
                  ) : (
                    <InputV
                      errors={methods.formState.errors}
                      name={`scInputParams[${nestIndex}].scParameters[${k}].scParameterDefaultValue`}
                      register={methods.register}
                      fullWidth
                      control={methods.control}
                      defaultValue={row.scParameterDefaultValue}
                      margin="dense"
                    />
                  )}
                </Grid>
                {/*  */}

                <Grid item xs={1}>
                  <SelectV
                    name={`scInputParams[${nestIndex}].scParameters[${k}].scParameterLogMode`}
                    options={[
                      { value: 'LOGGABLE', label: 'LOGGABLE' },
                      { value: 'NOT_LOGGABLE', label: 'NOT_LOGGABLE' },
                      { value: 'MASK', label: 'MASK' },
                    ]}
                    control={methods.control}
                    rules={['required']}
                    errors={methods.formState.errors}
                    fullWidth
                    defaultValue={row.scParameterLogMode || 'LOGGABLE'}
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={2}>
                  <InputV
                    fullWidth
                    errors={methods.formState.errors}
                    name={`scInputParams[${nestIndex}].scParameters[${k}].scParameterDesc`}
                    register={methods.register}
                    control={methods.control}
                    defaultValue={row.scParameterDesc}
                    margin="dense"
                  />
                </Grid>
              </Grid>
            </div>

            <NestedField2
              nestIndex={nestIndex}
              nestIndex2={k}

              ref={(el) => (childRef.current[k] = el)}
            />
          </React.Fragment>
        );
      })}

      { }
    </>
  );
});

export default NestedFieldArray;
